import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Device Header Plugin.
 *
 * @remarks
 * The plugin is enabled via the remote configuration for applicable clients.
 */
export const addDeviceHeaderPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const deviceHeader = 'foundation.plugin.deviceHeader';
  const { remoteConfig } = partialBuilderConfig;

  const enabled =
    typeof pluginConfigs[deviceHeader]?.enabled === 'boolean'
      ? pluginConfigs[deviceHeader].enabled
      : remoteConfig.drm?.appendDeviceHeaders;

  if (!enabled) {
    return pluginConfigs;
  }

  return { ...pluginConfigs, [deviceHeader]: { enabled: true } };
};
